/* MyPopMee - Traduction native MadeMine (FR depuis l'origine ; DE/ES/IT/NL ajoutées le 21/10/2026,
 * codes vérifiés sur le personnalisateur : de_DE, es_ES, it_IT, nl_NL). EN = langue par défaut de l'app.
 * Aucune traduction fictive du DOM ; l'app MadeMine possède les libellés fr_FR
 * et traduit également ses propres messages/étapes de personnalisation.
 */
(function () {
  'use strict';
  var locale = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  var MADEMINE_LANG = {fr: 'fr_FR', de: 'de_DE', es: 'es_ES', it: 'it_IT', nl: 'nl_NL'};
  var lang = MADEMINE_LANG[locale];
  if (!lang) return;
  var done = false;
  function localize() {
    if (done) return true;
    var app = window.CustomeowMademineApp;
    var props = window._mademineDebug && window._mademineDebug.props;
    var root = document.getElementById('mademine-node');
    if (!app || typeof app.render !== 'function' || !props || !props.shopConfig ||
        !root || !root.querySelector('.sc-layout')) return false;
    // Réutiliser les paramètres de l'app fournisseur sans modifier les prix
    // ni les callbacks d'ajout au panier.
    props.shopConfig.language = lang;
    try {
      app.render(Object.assign({}, props, {
        shopConfig: Object.assign({}, props.shopConfig, {language: lang})
      }), root);
      done = true;
      return true;
    } catch (e) {
      return false;
    }
  }
  function boot() {
    if (localize()) return;
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (localize() || tries >= 80) clearInterval(interval);
    }, 200);
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
